/* RESIN GAMES — JS propio (vanilla, sin librerías) */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* Galería de producto: cambiar imagen principal al pulsar miniatura */
  function initGallery() {
    var gal = document.querySelector('.mt-gallery');
    if (!gal) return;
    var main = gal.querySelector('.mt-gallery__main img');
    var thumbs = gal.querySelectorAll('.mt-gallery__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.setAttribute('src', full);
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* Selector de variantes: actualiza id, precio y estado */
  function initVariants() {
    var form = document.querySelector('[data-mt-product]');
    if (!form) return;
    var dataEl = form.querySelector('[data-mt-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('.mt-variants select');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-mt-price]');
    var addBtn = form.querySelector('.mt-buy__add');
    var addLabel = addBtn ? addBtn.getAttribute('data-label') : 'Añadir al carrito';
    var soldLabel = addBtn ? addBtn.getAttribute('data-sold') : 'Agotado';

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2 }) + ' €';
    }
    function current() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }
    function update() {
      var v = current();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = money(v.price) + ' <s>' + money(v.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; addBtn.textContent = addLabel; }
        else { addBtn.disabled = true; addBtn.textContent = soldLabel; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  function boot() {
    initReveal();
    initGallery();
    initVariants();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
